// A complimentary unlock is product usage, never paid revenue.
export function getItineraryPaymentEvent(payment = {}) {
  const amount = Number.isFinite(payment.amount) ? payment.amount : 0;
  const isPromo = payment.object === 'promo' || String(payment.id || '').startsWith('promo:');
  return {
    eventName: isPromo || amount <= 0 ? 'itinerary_promo_unlock' : 'itinerary_unlock_purchase',
    value: Math.max(0, amount) / 100,
  };
}
